export const ROLES = ["super_admin", "admin", "event_manager", "team_member"];

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  admin: "Admin",
  event_manager: "Event Manager",
  team_member: "Team Member",
};

export const ROLE_DESCRIPTIONS = {
  super_admin: "Full control, including managing other admins.",
  admin: "Everything except changing Super Admins.",
  event_manager: "Runs events, guests, forms, documents and Past Work.",
  team_member: "Works on events, guests and responses. Cannot delete.",
};

export const ROLE_STYLES = {
  super_admin: "bg-primary text-primary-foreground",
  admin: "bg-amber-100 text-amber-900",
  event_manager: "bg-sky-100 text-sky-800",
  team_member: "bg-secondary text-foreground",
};

export const PERMISSIONS = [
  { key: "events", label: "View & edit events, guests, responses", roles: ROLES },
  { key: "delete", label: "Delete events, guests, forms, documents", roles: ["super_admin", "admin", "event_manager"] },
  { key: "forms", label: "Build & publish guest forms", roles: ["super_admin", "admin", "event_manager"] },
  { key: "pastwork", label: "Manage Past Work portfolio", roles: ["super_admin", "admin", "event_manager"] },
  { key: "marketplace", label: "Buy Now marketplace, services & vendors", roles: ["super_admin", "admin"] },
  { key: "team", label: "Approve requests & send invitations", roles: ["super_admin", "admin"] },
  { key: "superadmin", label: "Manage Super Admins", roles: ["super_admin"] },
];

export function can(user, perm) {
  if (!user || user.status !== "approved") return false;
  const p = PERMISSIONS.find((x) => x.key === perm);
  return !!p && p.roles.includes(user.role);
}

export function assignableRoles(user) {
  return user?.role === "super_admin" ? ROLES : ROLES.filter((r) => r !== "super_admin");
}
